import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { EmploymentRecordActions, EmploymentRecordActionTypes } from './employment-record.actions';
import { EmploymentRecordEntity } from './employment-record.model';

export type EmploymentRecordEntities = EntityState<EmploymentRecordEntity>;

export const adapter: EntityAdapter<EmploymentRecordEntity> =
  createEntityAdapter<EmploymentRecordEntity>();

export const initialState: EmploymentRecordEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): EmploymentRecordEntities {
  const action = incomingAction as EmploymentRecordActions;
  switch (action.type) {
    case EmploymentRecordActionTypes.AddEmploymentRecord: {
      return adapter.addOne(action.payload.employmentRecord, state);
    }

    case EmploymentRecordActionTypes.UpsertEmploymentRecord: {
      return adapter.upsertOne(action.payload.employmentRecord, state);
    }

    case EmploymentRecordActionTypes.AddEmploymentRecords: {
      return adapter.addMany(action.payload.employmentRecords, state);
    }

    case EmploymentRecordActionTypes.UpsertEmploymentRecords: {
      return adapter.upsertMany(action.payload.employmentRecords, state);
    }

    case EmploymentRecordActionTypes.UpdateEmploymentRecord: {
      return adapter.updateOne(action.payload.employmentRecord, state);
    }

    case EmploymentRecordActionTypes.UpdateEmploymentRecords: {
      return adapter.updateMany(action.payload.employmentRecords, state);
    }

    case EmploymentRecordActionTypes.DeleteEmploymentRecord: {
      return adapter.removeOne(action.payload.id, state);
    }

    case EmploymentRecordActionTypes.DeleteEmploymentRecords: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case EmploymentRecordActionTypes.LoadEmploymentRecords: {
      return adapter.setAll(action.payload.employmentRecords, state);
    }

    case EmploymentRecordActionTypes.ClearEmploymentRecords: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
